module.exports = __webpack_public_path__ + "img/logo.d322f6ad.png";